import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { ReportScheduleModel } from '../../models/report-schedule.model';

@Injectable({
    providedIn: 'root'
})
export class ReportSchedulesResource extends BaseEntityResource<ReportScheduleModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'report-schedules' }));
    }

    /**
     * Returns the report schedule for a report.
     */
    getByReportId(reportId: string): Observable<ApiResponseModel<ReportScheduleModel>> {
        return this._requestService.makeGet<ApiResponseModel<ReportScheduleModel>>(this.getUrl(`report/${reportId}`));
    }
}
